export const FeedbackContent = {
    title: 'Enhance answers with AI feedback',
    content: 'Show additional feedback generated by AI. This AI feedback is shown after teachers and students submit the task.',
    example: 'The correct answer is B. "Is given" is the passive form of "give," indicating that the subject of the sentence receives the action rather than performs it.',
    score_color: 'text-danger',
    score: ' Score: 0 points.',
    btn_name: 'Add AI Feedback',
    credit_info: 'This feature will consume credits',
};
export const GradingContent = {
    title: "Use AI to grade this task",
    content: "Upgrade to AI grading. AI evaluates and adjusts scores with explanations for each task submission by you or your students.",
    example: "The answer is partially correct. It retains the original meaning and uses the correct keyword but uses an incorrect verb form 'builded' instead of 'built'. ",
    score_color: "text-partial",
    score: " Score: 0.5 points.",
    btn_name: "Add AI grading",
    credit_info: "This feature will consume credits for every submission",
};